<template>
    <footer class="footer-container">
        <span>&copy; {{ new Date().getFullYear() }} - Mosaic</span>
    </footer>
</template>